
import { useState,useEffect } from "react";
import mastercourseapi from '../api/mastercourse';
import loginapi from '../api/login';

import Course from '../components/MasterCourseComponent';

function MasterCourse({accessToken,setAccessToken,setRefreshFailed}) {
  const [courses,setCourses]=useState([]);    
  const [isAppLoaded,setIsAppLoaded]=useState(false);
 

  

  useEffect(()=>{
    const fetchAT=async ()=>{

      try{   
                 setIsAppLoaded(false);    
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await mastercourseapi.post('/getAllCourses',{id:1},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data));
        setCourses(response.data);
        //alert(response.data);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await mastercourseapi.post('/getAllCourses',{id:1},{headers:{'Authorization':`Bearer ${nat}`}});                       
                        //alert(JSON.stringify(response.data));
                        setCourses(response.data);
                        //alert(response.data);
                    }
                    catch(err)
                    {
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[]);
  
  
  
    return (
      <main>
        <div >
            <div className="text-center"><h1 className="text-2xl font-bold text-gray-800">MASTER COURSE LIST</h1></div>
            {!isAppLoaded ? (
  <p className="text-center">Please wait...</p>
) : courses.length > 0 ? (
  courses.map((course, index) => (
    <Course
      key={course.code}
      course={course}
      slno={index + 1}
      accessToken={accessToken}
      setAccessToken={setAccessToken}
      setRefreshFailed={setRefreshFailed}
    />
  ))
) : (
  <p>No courses available.</p>
)}
      </div>
     
      </main>
    )
  }
  
  export default MasterCourse